var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.loading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-two-line, list-item-two-line"
    }
  }) : _c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', [!_vm.isCustomSenderSelection ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_vm.from.length <= 1 ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.template.dialog.preview.sender'),
      "disabled": "",
      "value": _vm.senderNames[0],
      "hide-selected": "",
      "flat": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto"
    }
  }) : _c('combo-box', {
    attrs: {
      "dense": "",
      "label": _vm.$t('components.template.dialog.preview.sender'),
      "multiple": false,
      "items": _vm.senderNames,
      "hide-details": "auto"
    },
    on: {
      "changeSelection": _vm.changeSenderSelection,
      "changeIsValid": _vm.changeIsSenderSelectionValid
    }
  })], 1) : _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_vm._t("senderSelection")], 2), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('combo-box', {
    attrs: {
      "dense": "",
      "label": _vm.$t('components.template.dialog.preview.receiver'),
      "items": _vm.to,
      "rules": _vm.receiverMailRules,
      "hide-details": "auto"
    },
    on: {
      "changeSelection": _vm.changeReceiverSelection,
      "changeIsValid": _vm.changeIsReceiverSelectionValid
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "rules": _vm.textRules,
      "outlined": "",
      "label": _vm.$t('components.template.dialog.preview.subject'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.renderedSubject,
      callback: function callback($$v) {
        _vm.renderedSubject = $$v;
      },
      expression: "renderedSubject"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "dense": "",
      "no-gutters": ""
    }
  }, [_vm.partnerId && _vm.portalContext && _vm.canCreateDocument && _vm.isAttachmentEnabled ? _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_vm.attachments.length > 0 ? _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.attachments, function (a, i) {
    return _c('v-col', {
      key: a.id || a.name + i,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4",
        "lg": "3",
        "xl": "2"
      }
    }, [_c('v-card', {
      attrs: {
        "outlined": "",
        "elevation": "0",
        "loading": a.isLoadingInternal
      }
    }, [_c('v-row', {
      attrs: {
        "dense": "",
        "align": "center",
        "no-gutters": ""
      }
    }, [_c('v-col', {
      staticClass: "mr-2",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "32",
        "color": "red darken-1"
      }
    }, [_vm._v("mdi-file-pdf-box")])], 1), a.isUploadError ? _c('v-col', [_c('span', {
      staticClass: "text-caption grey--text text-truncate d-block"
    }, [_vm._v(" " + _vm._s(_vm.$t("components.template.dialog.preview.uploadError", {
      fileName: a.name
    })) + " ")]), _c('v-btn', {
      attrs: {
        "x-small": "",
        "elevation": "0",
        "color": "warning"
      },
      on: {
        "click": function click($event) {
          return a.create();
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("components.template.dialog.preview.reupload")))])], 1) : _c('v-col', {
      staticClass: "text-truncate"
    }, [_c('span', {
      staticClass: "text-caption grey--text text-truncate d-block"
    }, [_vm._v(" " + _vm._s(a.name) + " ")]), _c('span', {
      staticClass: "text-caption grey--text d-block"
    }, [_vm._v(" " + _vm._s(_vm._f("formatBytes")(a.size)) + " ")])]), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "x-small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.removeAttachment(i);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-close")])], 1)], 1)], 1)], 1)], 1);
  }), 1) : _vm._e()], 1) : _vm._e(), _vm.partnerId && _vm.portalContext && _vm.canCreateDocument && _vm.isAttachmentEnabled ? _c('v-col', {
    staticClass: "d-flex align-center mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "close-on-content-click": true
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "px-0",
          attrs: {
            "text": "",
            "small": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-paperclip")]), _vm._v(" " + _vm._s(_vm.$t("components.template.dialog.preview.addAttachment")) + " ")], 1)];
      }
    }], null, false, 3064565905),
    model: {
      value: _vm.attachmentMenu,
      callback: function callback($$v) {
        _vm.attachmentMenu = $$v;
      },
      expression: "attachmentMenu"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    on: {
      "click": _vm.onPickLocalFile
    }
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t("components.template.dialog.preview.browseThisComputer")))])], 1), _c('v-list-item', {
    on: {
      "click": function click($event) {
        _vm.documentSelectDialog = true;
      }
    }
  }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("components.template.dialog.preview.selectFileFromPlatform")) + " ")])], 1)], 1)], 1), _c('input', {
    ref: "localFileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "application/pdf,.pdf"
    },
    on: {
      "change": _vm.onLocalFilesSelected
    }
  }), _c('document-selection-simple-dialog', {
    key: 'document-selection-dialog-' + _vm.refKey,
    attrs: {
      "isDialogActive": _vm.documentSelectDialog,
      "filters": _vm.attachmentFileFilters,
      "selectedItems": _vm.selected
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.documentSelectDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.documentSelectDialog = $event;
      },
      "update:selectedItems": function updateSelectedItems($event) {
        _vm.selected = $event;
      },
      "update:selected-items": function updateSelectedItems($event) {
        _vm.selected = $event;
      },
      "selected": _vm.attachDocuments
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('template-editor', {
    key: _vm.k,
    attrs: {
      "isPlain": _vm.template.meta.contentFormat === _vm.MessageContentFormatEnum.PLAIN,
      "readOnly": false,
      "partnerId": _vm.partnerId,
      "isMobile": _vm.isMobile,
      "label": _vm.$t('components.template.detail.body.body')
    },
    model: {
      value: _vm.renderedBody,
      callback: function callback($$v) {
        _vm.renderedBody = $$v;
      },
      expression: "renderedBody"
    }
  }, [_vm.hasTokens ? _c('span', [_c('v-btn', {
    class: _vm.isMobile ? 'mr-n1 ml-n1' : 'pr-0 pl-0',
    attrs: {
      "text": "",
      "small": "",
      "icon": _vm.isMobile,
      "color": _vm.isTokenWithoutValue ? 'error' : ''
    },
    on: {
      "click": function click($event) {
        _vm.customTokenDialog = true;
      }
    }
  }, [!_vm.isMobile ? _c('small', {
    staticClass: "mr-1 ml-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.template.dialog.preview.customTokens")) + " ")]) : _vm._e(), !_vm.isMobile ? _c('v-icon', {
    attrs: {
      "color": _vm.isTokenWithoutValue ? 'error' : ''
    }
  }, [_vm._v(" mdi-list-status ")]) : _c('tooltip', {
    staticClass: "mr-n1 ml-n1",
    attrs: {
      "text": _vm.$t('components.template.dialog.preview.missingTokens')
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": _vm.isTokenWithoutValue ? 'error' : ''
    }
  }, [_vm._v(" mdi-list-status ")])], 1)], 1), _c('template-editor-action-divider')], 1) : _vm._e(), _vm.canReadTemplate ? _c('span', [_c('template-selection-dialog', {
    attrs: {
      "partnerId": _vm.partnerId,
      "context": _vm.extendedContext
    },
    on: {
      "select": _vm.setTemplate
    }
  }), !(_vm.template.meta.contentFormat === _vm.MessageContentFormatEnum.PLAIN) ? _c('template-editor-action-divider') : _vm._e()], 1) : _vm._e()])], 1)], 1), _vm.problems.length > 0 ? _c('v-row', {
    staticClass: "mb-n5 mt-n6"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, _vm._l(_vm.problems, function (problem) {
    return _c('small', {
      key: problem
    }, [_vm._v(_vm._s(problem))]);
  }), 0)], 1) : _vm._e(), _vm.customTokenDialog ? _c('div', [_c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('components.template.dialog.preview.customTokens'),
      "isDialogActive": _vm.customTokenDialog,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.customTokenDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.customTokenDialog = $event;
      },
      "rightClick": function rightClick($event) {
        _vm.customTokenDialog = false;
      }
    }
  }, _vm._l(_vm.template.content.tokens, function (token) {
    return _c('div', {
      key: token
    }, [_c('v-text-field', {
      attrs: {
        "value": _vm.getValue(token),
        "label": _vm.getLabel(token),
        "outlined": ""
      },
      on: {
        "input": function input(v) {
          return _vm.debounceInput(v, token);
        }
      }
    })], 1);
  }), 0)], 1) : _vm._e(), _vm.isTicketEnabled && _vm.canCreateTicket ? _c('div', [_c('ticket-create-checkbox', {
    attrs: {
      "enabled": _vm.createReminder
    },
    on: {
      "update:enabled": function updateEnabled($event) {
        _vm.createReminder = $event;
      }
    },
    model: {
      value: _vm.reminderDate,
      callback: function callback($$v) {
        _vm.reminderDate = $$v;
      },
      expression: "reminderDate"
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }